// types.ts

// Định nghĩa các trang chính của ứng dụng để quản lý điều hướng
export type Page = 'dashboard' | 'rooms' | 'tenants' | 'statistics' | 'guide' | 'backup';

// Enum cho trạng thái phòng, sử dụng tiếng Anh để dễ xử lý logic
export enum RoomStatus {
    Available = 'available',
    Occupied = 'occupied',
    Maintenance = 'maintenance',
}

// Enum cho trạng thái cư trú
export enum ResidencyStatus {
    Unregistered = 'unregistered',
    Registered = 'registered',
    Expired = 'expired',
    Notifying = 'notifying',
}

// Thông tin chi tiết về nhà trọ, lấy từ phần Cài đặt
export interface BoardingHouseInfo {
    name: string;
    address: string;
    ward?: string;
    city?: string;
    phone: string;
    landlordName: string;
    landlordDob?: string;
    landlordIdNumber?: string;
    defaultRoomPrice: number;
    numberOfRooms: number; // Thêm số lượng phòng
    // For Contract and CT01 modals
    hostName?: string;
    hostBirthDate?: string;
    hostIdNumber?: string;
    hostIdIssueDate?: string;
    hostIdIssuePlace?: string;
    hostPermanentAddress?: string;
    localPoliceDepartment?: string;
}

// Thông tin chi tiết về phòng
export interface Room {
    id: string;
    roomNumber: string;
    price: number;
    status: RoomStatus;
    tenantId?: string; // ID của khách thuê chính trong phòng
    lastElectricityReading: number;
    currentElectricityReading: number;
    area?: number; // Diện tích phòng
    maxOccupancy?: number; // Số người ở tối đa
    notes?: string;
    amenities?: string[];
}

// Thông tin chi tiết về khách thuê chính (chủ hợp đồng)
export interface Tenant {
    id: string;
    name: string;
    gender: 'Nam' | 'Nữ' | 'Khác';
    idType: 'CCCD' | 'CMND' | 'Hộ chiếu';
    idNumber: string;
    phone: string;
    permanentAddress: string; // Thường trú
    dateOfBirth: string; // yyyy-mm-dd
    idIssueDate: string; // yyyy-mm-dd
    idIssuePlace?: string;
    roomId: string;
    contractStartDate: string; // yyyy-mm-dd
    contractEndDate?: string; // yyyy-mm-dd
    depositAmount?: number;
    documentUrl?: string;
    notes?: string;
}

// Thông tin về thành viên ở cùng phòng với khách thuê chính
export interface RoomMember {
    id: string;
    tenantId: string; // ID của khách thuê chính để liên kết
    name: string;
    gender: 'Nam' | 'Nữ' | 'Khác';
    idType: 'CCCD' | 'CMND' | 'Hộ chiếu';
    idNumber: string;
    phone: string;
    permanentAddress: string;
    dateOfBirth: string;
    idIssueDate: string;
    idIssuePlace?: string;
    relationship: string;
}

// Thông tin đăng ký tạm trú, tạm vắng
export interface ResidencyRegistration {
    id: string;
    personId: string; // ID của Tenant hoặc RoomMember
    status: ResidencyStatus;
    temporaryAddress: string;
    arrivalDate: string; // yyyy-mm-dd
    departureDate: string; // yyyy-mm-dd
    notes?: string;
}

// Cấu trúc tổng hợp để quản lý toàn bộ dữ liệu của một nhà trọ
export interface BoardingHouse {
    id: string;
    info: BoardingHouseInfo;
    rooms: Room[];
    tenants: Tenant[];
    roomMembers: RoomMember[];
    residencyRegistrations: ResidencyRegistration[];
}